import React from "react";
import { Link } from "react-router-dom";

import ldaLogo from "../../../layout/main-menu/assets/lda-logo.svg";
import legacyLinkLogo from "../../../layout/main-menu/assets/legacy-link-logo.svg";
import { ROUTES } from "../../../system/router/routes";
import * as Styled from "./auth.styled";

type AuthLayoutProps = {
  children: React.ReactNode;
  alert?: React.ReactNode;
  demo?: boolean;
  dimmed?: boolean;
};

export const AuthLayout = ({
  children,
  alert,
  demo,
  dimmed,
}: AuthLayoutProps) => (
  <Styled.AuthPage $dimmed={dimmed}>
    <Styled.Header>
      <Styled.BrandGroup>
        <Styled.BrandPrefix>by</Styled.BrandPrefix>
        <Styled.LdaLogo src={ldaLogo} alt="Legacy Data Access" />
        <Styled.BrandName>Legacy Data Access</Styled.BrandName>
      </Styled.BrandGroup>

      <Styled.CenterBrand>
        <Link to={ROUTES.SIGN_IN} aria-label="LegacyLink sign in">
          <Styled.LegacyLogo src={legacyLinkLogo} alt="LegacyLink" />
        </Link>
        {demo ? <Styled.DemoBadge>Demo</Styled.DemoBadge> : null}
      </Styled.CenterBrand>

      <span />
    </Styled.Header>

    <Styled.Content>
      <div>
        {alert}
        {children}
      </div>
    </Styled.Content>

    <Styled.Footer>
      <Link to={ROUTES.NEED_HELP}>Need help?</Link>
      <div>© 2026 Legacy Data Access. All rights reserved.</div>
    </Styled.Footer>
  </Styled.AuthPage>
);
